// extracted by css-extract-rspack-plugin
export default {"grid":"NTYj_9tNwz4VPDJZ","tile":"JJ46IzIGwW1VHqGI","count":"RWVDePBNpQf3waxY","label":"jCl3uDPmTQxSFaeC"};